import { useEffect } from 'react';
import { useLocation } from 'react-router';
import { buildIdeatJsonLd } from '../../ssr/ideatJsonLd.js';
import { setHeadJsonLd } from './useHeadJsonLd.js';
import { createCanonicalUrl } from './useMeta.js';
import type { IdeatJsonLdProps } from '../../ssr/ideatJsonLd.js';

export const useIdeatJsonLd = (props: IdeatJsonLdProps) => {
  const { pathname } = useLocation();

  useEffect(() => {
    setHeadJsonLd(buildIdeatJsonLd(createCanonicalUrl(pathname), props));

    return () => setHeadJsonLd('');
  }, [props, pathname]);
};
